import styled, { css } from "../../../__compat__/styled-components/main.entry.mjs.mjs";
import { toCSSCustomIdent } from "../../../utils/cssUtils.mjs.mjs";
import { injectOSXFontSmoothing } from "../../../utils/injectOSXFontSmoothing.mjs.mjs";
import { injectTypography } from "../../../utils/injectTypography.mjs.mjs";
import { responsiveStyles } from "../../../utils/responsiveStyles.mjs.mjs";
export const gridSize = 48;
export const StyledCalendarGrid = styled.div.attrs((props) => ({
    weekdays: props.weekdays.map(toCSSCustomIdent),
})).withConfig({ displayName: "auir-611444a-StyledCalendarGrid", componentId: "auir-611444a-thyekq" }) `
  display: grid;

  grid-auto-rows: ${gridSize}px;

  ${(props) => {
    return responsiveStyles({
        'grid-template-columns': {
            xs: props.weekdays.map((day) => `[${day}] 1fr`).join(' '),
            m: props.weekdays.map((day) => `[${day}] ${gridSize}px`).join(' '),
        },
    }, props.theme.breakpoints);
}}
`;
export const StyledCalendarDayHeader = styled.div.attrs((props) => ({
    weekday: toCSSCustomIdent(props.weekday),
})).withConfig({ displayName: "auir-611444a-StyledCalendarDayHeader", componentId: "auir-611444a-1kf4qgn" }) `
  display: flex;
  grid-column: ${(props) => props.weekday};
  align-items: center;
  justify-content: center;

  color: var(${(props) => props.theme.colors.ui.tertiary});
  ${(props) => injectTypography(props, 'copy2')}
  ${injectOSXFontSmoothing(true)}
`;
export const StyledCalendarDay = styled.button.attrs((props) => ({
    weekday: toCSSCustomIdent(props.weekday),
})).withConfig({ displayName: "auir-611444a-StyledCalendarDay", componentId: "auir-611444a-10bwv0w" }) `
  ${(props) => injectTypography(props, 'copy1')}
  ${injectOSXFontSmoothing(true)}

  grid-column: ${(props) => props.weekday};
  margin: 0;
  padding: 0;

  color: var(${(props) => props.theme.colors.interaction.primary.default});
  text-align: center;

  background-color: transparent;

  border: none;
  border-radius: 0;

  cursor: pointer;

  transition: 150ms var(${(props) => props.theme.easing});
  transition-property: color, background-color;

  appearance: none;

  &:focus {
    z-index: 1;
  }

  &[aria-disabled='true'] {
    color: var(${(props) => props.theme.colors.interaction.primary.disabled});

    cursor: not-allowed;
  }

  &:not([aria-disabled='true'], [aria-pressed='true']):hover {
    color: var(${(props) => props.theme.colors.ui.inverted});

    background-color: var(
      ${(props) => props.theme.colors.interaction.primary.hover}
    );
  }

  &[aria-pressed='true'],
  &[aria-disabled='true'][aria-pressed='true'] {
    color: var(${(props) => props.theme.colors.ui.inverted});

    background-color: var(
      ${(props) => props.theme.colors.interaction.primary.pressed}
    );
    cursor: initial;
  }

  ${(props) => props.selectedRange &&
    css `
      background-color: var(
        ${(props) => props.theme.colors.ui.highlight.tertiary}
      );
    `}
`;
export const StyledTodayText = styled.span.withConfig({ displayName: "auir-611444a-StyledTodayText", componentId: "auir-611444a-qqo41v" }) `
  padding-bottom: 2px;

  font-weight: var(${(props) => props.theme.fontWeights.bold});

  border-bottom: 2px solid currentColor;

  transition: border-color 150ms var(${(props) => props.theme.easing});
`;
//# sourceMappingURL=Calendar.styles.mjs.mjs.map